'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherCalendar, FeatherLock, FeatherUser } from '@subframe/core';
import type { FaturaHistoricoEntry } from '../types';
import { formatarDataHora } from '../utils/faturaFormatters';
import { historicoAcaoConfig } from '../utils/faturaStatusConfig';
interface FaturaHistoricoAbaProps {
  historico: FaturaHistoricoEntry[];
}
const dotClassByVariant: Record<string, string> = {
  success: 'bg-success-100 text-success-700',
  warning: 'bg-warning-100 text-warning-700',
  error: 'bg-error-100 text-error-700',
  brand: 'bg-brand-100 text-brand-700',
  neutral: 'bg-neutral-100 text-neutral-700'
};
export function FaturaHistoricoAba(t0) {
  const $ = _c(14);
  const {
    historico
  } = t0;
  if (historico.length === 0) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="bg-default-background flex flex-col items-center justify-center gap-2 rounded-[16px] border border-dashed border-neutral-200 px-6 py-12 text-center"><span className="text-body-bold font-body-bold text-default-font">Histórico ainda vazio</span><span className="text-body font-body text-subtext-color">As ações executadas nesta fatura aparecerão aqui em ordem cronológica.</span></div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[1] !== historico) {
    const ordenadas = [...historico].sort(_temp);
    t3 = "flex flex-col gap-4";
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <div className="bg-default-background flex items-center gap-2 rounded-[12px] border border-solid border-neutral-200 px-4 py-3 text-sm text-neutral-600"><FeatherLock className="h-4 w-4 text-neutral-400" />Histórico imutável — não pode ser editado ou excluído</div>;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    t1 = "border-l-2 border-neutral-200";
    t2 = ordenadas.map((entry, index) => {
      const config = historicoAcaoConfig[entry.acao];
      const Icon = config.icon;
      return <li key={entry.id} className={`relative ml-[-9px] pl-6 ${index === ordenadas.length - 1 ? "" : "pb-6"}`}><span className={`absolute top-0 left-0 flex h-4 w-4 items-center justify-center rounded-full border-2 border-white ${dotClassByVariant[config.variant] ?? dotClassByVariant.neutral}`}><Icon className="h-2.5 w-2.5" /></span><div className="flex flex-col gap-2 pl-2"><div className="flex flex-wrap items-center gap-2"><span className="text-body-bold font-body-bold text-default-font">{config.label}</span><span className="text-caption font-caption text-subtext-color">·</span><span className="text-caption font-caption text-subtext-color flex items-center gap-1"><FeatherCalendar className="h-3 w-3" />{formatarDataHora(entry.timestamp)}</span></div><p className="text-body font-body text-neutral-700">{entry.descricao}</p><div className="text-caption font-caption text-subtext-color flex items-center gap-1.5"><FeatherUser className="h-3 w-3" />{entry.usuarioNome ?? "Sistema (autom\xE1tico)"}</div>{entry.detalhes && Object.keys(entry.detalhes).length > 0 && <div className="rounded-[8px] bg-neutral-50 px-3 py-2 text-xs text-neutral-700">{Object.entries(entry.detalhes).map(_temp2)}</div>}</div></li>;
    });
    $[1] = historico;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t2) {
    t5 = <ol className={t1}>{t2}</ol>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t4 || $[12] !== t5) {
    t6 = <div className={t3}>{t4}{t5}</div>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}
function _temp2(t0) {
  const [key, value] = t0;
  return <div key={key} className="flex gap-2"><span className="text-subtext-color font-medium">{key}:</span><span className="text-default-font">{String(value)}</span></div>;
}
function _temp(a, b) {
  return new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime();
}